// extracted by css-extract-rspack-plugin
export default {"subfields":"subfields-2TkCB"};